export const rangeOptions = [
    {
        value: '',
        label: '全部对象',
    },
    {
        value: 'subscribed',
        label: '已订阅',
    },
    {
        value: 'unsubscribed',
        label: '未订阅',
    },
]

export const tableColumns = [
    {
        title: '中文名称',
        dataIndex: 'chnName',
        key: 'chnName',
    },
    {
        title: '英文名称',
        dataIndex: 'engName',
        key: 'engName',
    },
    {
        title: '类型',
        dataIndex: 'opprop',
        key: 'opprop',
    },
    {
        title: '所属国家',
        dataIndex: 'loccountry',
        key: 'loccountry',
    },
  ]
